import {TimeStream} from '../utils';


const defaults = {
    initialized: false,
    globalIndex: 1,
    messages: [],
    lecture: null,
    currentAudioItem: null,
    autoPlay: false,
    toTexts: [], // [{ id: 1, status: 'pending', text: 'hahahahaha', via: 'xunfei' }]
};


const appendMessage = (state, payload) => {
    /* timestamp 可以维持发送顺序，并保持唯一性 */
    const timestamp = parseFloat(((Date.now() + state.globalIndex*0.001) * 0.001).toFixed(6));

    var m = {
        id: timestamp,
        type: payload.type,
        account: payload.account,
        sender_title: '',
        timestamp: payload.timestamp ? payload.timestamp : timestamp,
        create_time: TimeStream(Date.parse(new Date()) / 1000)
    };

    switch (m.type){
        case 'text':
            m.content = payload.content;
            m.status = 'send';
            m.meta = {
                reply: payload.reply
            }
            break
        case 'voice':
            m.local_id = payload.local_id
            m.audio = payload.audio
            m.from = payload.from
            m.content = payload.content
            m.status = m.from === 'pc' ? 'send': 'queued'
            m.meta = {
                length: payload.length,
                reply: payload.reply
            }
            break
        case 'image':
            m.local_id = payload.local_id
            m.image = payload.image
            m.from = payload.from
            m.content = payload.content
            m.status = m.from === 'pc' ? 'send': 'queued'
            break
       default:
            break
    }
    return [...state.messages, m];
};

export default (state=defaults, action) => {
    switch(action.type){
        case 'ML_LOAD':
            return {...state, 
                messages: action.payload.messages,
                initialized: true
            };
        case 'ML_SEND_MESSAGE': {
            const messages = appendMessage(state, action.payload);
            return {...state, messages: messages, globalIndex: state.globalIndex+1};
        }
        case 'ML_TOGGLE_MESSAGE': {
            const messages = state.messages.map(m => {
                if(m.id === action.payload.id){
                    var update = {status: action.payload.status};
                    if(action.payload.content){
                        update.content = action.payload.content;
                    }
                    if(action.payload.message){
                        update = {...update, ...action.payload.message};
                    }
                    return {...m, ...update};
                }
                return m;
            });
            return {...state, messages: messages};
        }
        case 'ML_RECEIVE_MESSAGE':{
            const found = state.messages.find((m) => m.timestamp === action.payload.timestamp);
            if(found)
                return state;
            action.payload.status = 'scroll';
            action.payload.receive_timestamp = Date.now() * 0.001;

            return {...state, messages: [...state.messages, action.payload]};
        }
        case 'ML_DELETE_MESSAGE': {
            const messages = state.messages.filter(m=>m.id !== action.payload.id)
            if(state.currentAudioItem && state.currentAudioItem.props.message.id === action.payload.id){
                return {...state, messages: messages, currentAudioItem: null}
            }
            return {...state, messages: messages}
        }
        case 'AUDIO_LOAD':
            return {...state,
                currentAudioItem: action.payload.messageItem
            }
        case 'PAGE_INIT':
            return {...state, messages: [], lecture: null};
        case 'ML_SET_AUTOPLAY':
            return {...state, autoPlay: true, autoPlayId: action.payload};
        case 'ML_UNSET_AUTOPLAY':
            return {...state, autoPlay: false};
        case 'ML_ADD_TO_TEXT': 
            return {...state, toTexts: [...state.toTexts, action.payload]}
        case 'ML_SET_TO_TEXT':
            const cpToTextState = state.toTexts.slice()
            state.toTexts.forEach((item, i) => {
                if (action.payload.id === item.id) {
                    cpToTextState[i] = action.payload
                }
            })
            return {...state, toTexts: cpToTextState}
        default:
            return state;
    }
}





// WEBPACK FOOTER //
// ./src/reducers/messageList.js